export default __webpack_public_path__ + "static/media/hide.0bed875c.svg";